import { render, staticRenderFns } from "./scheduleCourse.vue?vue&type=template&id=54984395&scoped=true"
import script from "./scheduleCourse.vue?vue&type=script&lang=js"
export * from "./scheduleCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54984395",
  null
  
)

export default component.exports